import { useState, useEffect } from "react";

// hook to check whether component have already been mounted
export const useMounted = () => {
    const [isMounted, setMounted] = useState(false);
    useEffect(() => setMounted(true), []);
    return isMounted;
};

// hook to check whether scrolled to bottom
export const useScrollBottom = () => {
    const [isBottom, setBottom] = useState(false);
    const scrollHandler = () => setBottom(window.innerHeight + window.scrollY >= document.body.offsetHeight);
    useEffect(() => {
        window.addEventListener("scroll", scrollHandler);
        return () => window.removeEventListener("scroll", scrollHandler); // cleanup
    }, []);
    return isBottom;
};

// hook to check whether online
export const useOnline = () => {
    const [isOnline, setOnline] = useState(navigator.onLine);
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    useEffect(() => {
        window.addEventListener("online", goOnline);
        window.addEventListener("offline", goOffline);
        return () => {
            window.removeEventListener("online", goOnline);
            window.removeEventListener("offline", goOffline);
        };
    }, []);
    return isOnline;
};
